import * as React from "react"
import { cn } from "@/lib/utils"

interface FilenameInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  extension?: string;
}

const FilenameInput = React.forwardRef<HTMLInputElement, FilenameInputProps>(
  ({ className, extension, ...props }, ref) => {
    return (
      <div className={cn(
        "flex w-full rounded-lg border border-input bg-white ring-offset-background focus-within:ring-0 focus-within:outline-hidden",
        className
      )}>
        <input
          type="text"
          className="flex-1 bg-transparent px-3 py-2 text-sm outline-hidden placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50"
          ref={ref}
          {...props}
        />
        {extension && (<span className="flex items-center pr-3 text-sm text-muted-foreground select-none">
          {extension}
        </span>)}
      </div>
    )
  }
)
FilenameInput.displayName = "FilenameInput"

export { FilenameInput }
